import { render, staticRenderFns } from "./PersonnelRecordDetailCardSkills.vue?vue&type=template&id=8e56c398"
import script from "./PersonnelRecordDetailCardSkills.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailCardSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports